import { ApiResponse } from "apisauce";
import Api from "../../../services/Api";

export const SET_COMPONENT_HEADER = 'SET_COMPONENT_HEADER';
export const SET_ONBASE_STATUS = 'SET_ONBASE_STATUS';

export const updateHeaderByComponent = (value: string) => {
  return {
      type: SET_COMPONENT_HEADER,
      value
    };
};

export const checkOnBaseStatus = () => {
  return async (dispatch) => {
    try {
      await Api.get("status/onbase").then((response: ApiResponse<any>) => {
        dispatch(reduceOnBaseStatus(response.data.isUp));
        return Promise.resolve(response.data.isUp);
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};

export const reduceOnBaseStatus = (value: boolean) => {
  return {
    type: SET_ONBASE_STATUS,
    value
  };
};